import styled from "styled-components"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import Sticky from "react-stickynode"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import { UseCase, UseCaseLayout } from "@/common/components/UseCase"

import lineGroupY from "@/common/assets/image/walletAsAService/showCase/premise/lineGroupY.svg"
import KGLOGO from "@/common/assets/image/walletAsAService/showCase/KGLOGO.webp"
import KGHero from "@/common/assets/image/walletAsAService/showCase/hero&banner/KG Hero.webp"
import KG1_P from "@/common/assets/image/walletAsAService/showCase/premise/KG1.svg"
import KG2_P from "@/common/assets/image/walletAsAService/showCase/premise/KG2.svg"
import KG3_P from "@/common/assets/image/walletAsAService/showCase/premise/KG3.svg"
import KG1_S from "@/common/assets/image/walletAsAService/showCase/solutions/KG1.webp"
import KG2_S from "@/common/assets/image/walletAsAService/showCase/solutions/KG2.webp"
import KG3_S from "@/common/assets/image/walletAsAService/showCase/solutions/KG3.webp"
import KG4_S from "@/common/assets/image/walletAsAService/showCase/solutions/KG4.webp"
import KG5_S from "@/common/assets/image/walletAsAService/showCase/solutions/KG5.webp"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))
const KryptogoWalletPage = () => {
  const { t } = useTranslation(["useCaseKG"])
  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/use-case/kryptogo-wallet"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/use-case/kryptogo-wallet"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/use-case/kryptogo-wallet"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/use-case/kryptogo-wallet"
          }
        ]}
      />
      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <LayoutWrapper>
        <UseCaseLayout
          content={
            <UseCase
              data={{
                hero: {
                  title1: t("hero.title1"),
                  title2: t("hero.title2"),
                  title3: t("hero.title3"),
                  desc: t("hero.desc"),
                  icon: KGLOGO,
                  btns: "",
                  hero: KGHero
                },
                showCaseCounter: [
                  {
                    content: t("counter.1.content"),
                    desc: t("counter.1.desc")
                  },
                  {
                    content: t("counter.2.content"),
                    desc: t("counter.2.desc")
                  },
                  { content: t("counter.3.content"), desc: t("counter.3.desc") }
                ],
                theySays: {
                  content1: t("theySays.content1"),
                  content2: t("theySays.content2")
                },
                premise: {
                  title2: t("premise.title2"),
                  content1: [t("premise.content1.1"), t("premise.content1.2")],
                  content2: [
                    { Icon: KG1_P, content: t("premise.content2.1") },
                    { Icon: KG2_P, content: t("premise.content2.2") },
                    { Icon: KG3_P, content: t("premise.content2.3") }
                  ],
                  result: t("premise.result"),
                  lineGroup: lineGroupY
                },
                solution: {
                  title: t("solution.title"),
                  QA: [
                    {
                      q: t("solution.1.q"),
                      a: t("solution.1.a"),
                      img: KG1_S
                    },
                    {
                      a: t("solution.2.a"),
                      q: t("solution.2.q"),
                      img: KG2_S
                    },
                    {
                      q: t("solution.3.q"),
                      a: t("solution.3.a"),
                      img: KG3_S
                    },
                    {
                      q: t("solution.4.q"),
                      a: t("solution.4.a"),
                      img: KG4_S
                    },
                    {
                      q: t("solution.5.q"),
                      a: t("solution.5.a"),
                      img: KG5_S
                    }
                  ]
                }
              }}
              next="stickey-wallet"
            />
          }
        />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "useCaseCommon",
      "useCaseKG"
    ]))
  }
})

export default KryptogoWalletPage

const LayoutWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
`
